import { createSelector } from 'reselect';
import { routeSelector } from './router';
import { Route } from 'config/routes';
import {
  unitPageBulletinSelector,
  projectPageProjectSelector,
  soldPageDealSelector,
  unitPageCommercialBulletinSelector,
  projectPageCommercialProjectSelector,
  lastViewedIdsSelector,
} from '../domainData/selectors';
import { State } from 'store/state';
import { marketplaceSelector } from 'store/state/selectors/router';
import { daysFrom } from 'helpers/dateUtils';
import { parseISODate } from 'locale/formatDate';
import { MarketplaceType, PoiId } from 'utils/entities';


export const currentPoiSelector = createSelector([
  routeSelector,
  unitPageBulletinSelector,
  projectPageProjectSelector,
  soldPageDealSelector,
  unitPageCommercialBulletinSelector,
  projectPageCommercialProjectSelector,
], (route, bulletin, project, deal, commercialBulletin, commercialProject) => {
  let poi = null;

  switch (route.name) {
    case Route.UnitPage:
      poi = bulletin;
      break;
    case Route.ProjectPage:
      poi = project;
      break;
    case Route.UnitPageCommercial:
      poi = commercialBulletin;
      break;
    case Route.ProjectPageCommercial:
      poi = commercialProject;
      break;
    case Route.Sold:
      poi = deal;
      break;
  }
  return poi;
});

const lastViewedPoiIdsSet = createSelector([
  lastViewedIdsSelector,
  marketplaceSelector,
], (ids, marketplace) => {
  let filteredIds = ids;

  const isResidential = marketplace === MarketplaceType.Residential;

  if (isResidential) {
    const MAX_DAYS_SINCE_LAST_VIEWED = 14;

    filteredIds = ids.filter((item => {
      return item.date ? daysFrom(parseISODate(item.date)) < MAX_DAYS_SINCE_LAST_VIEWED : false;
    }));
  }

  return new Set(filteredIds.map((i) => i.poiId.id));
});

export const isInLastViewedSelector = createSelector([
  lastViewedPoiIdsSet,
  (_: State, id: PoiId) => id,
], (set, id) => set.has(id));
